/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import { diferenciaHoras, getDateString2 } from "../../../../Base/Services/FechasService";
import { formatNumberDecimal } from "../../../../Base/Services/FormatTemplate";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";
import { getInformacionEmpresa } from "../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { getTomaInventarioReporte } from "../../../../API/Suministros/Inventario/InventarioRequest";

const ReporteTomaInventario = ({
  showReporte,
  setShowReporte,
  fechaReporte,
  setFechaReporte,
  IdTipoIngreso,
}) => {
  const [loading, setLoading] = useState(true);
  const [reporte, setReporte] = useState(null);
  const toast = useRef(null);
  const [IdCurrency, setIdCurrency] = useState(2);
  const [data, setData] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [infoEmpresa, setInfoEmpresa] = useState([]);

  const obtenerInformacion = async () => {
    setLoading(true);
    const monedasTempo = await ObtenerCurrency();
    setMonedas(monedasTempo);
    const infoEmpresaTempo = await getInformacionEmpresa();
    setInfoEmpresa(infoEmpresaTempo[0]);
    setFechaReporte(fechaReporte);
    AsignarInformacion(fechaReporte, 2, infoEmpresaTempo[0]);

    setLoading(false);
  };

  const AsignarInformacion = async (date, IdMon, infoEmpresa) => {
    setLoading(true);
    setFechaReporte(date);
    setIdCurrency(IdMon);
    const result = await getTomaInventarioReporte(
      getDateString2(date),
      IdTipoIngreso
    );
    setData(result);
    if (result?.length > 0) {
      GenerarReporte(result, IdMon, infoEmpresa);
    } else {
      GenerarReporte([], IdMon, infoEmpresa);
      toastShow( toast, "error", "Error", "No se encontro información con la fecha seleccionada");
    }
    setLoading(false);
  };

  const GenerarReporte = (data, IdMoneda, infoEmpresa) => {
    const cantidadProductos = data?.length
    const cantidadInv = data?.reduce((t, v) => t + v.Inventario, 0)
    const cantidadSistema = data?.reduce((t, v) => t + v.InventarioSistame, 0)
    const montoTotalL = data?.reduce((t, v) => t + v.MontoL, 0)
    const montoTotalD = data?.reduce((t, v) => t + v.MontoD, 0)
    const balanceTotal = data?.reduce((t, v) => t + v.Balance, 0)
    const horaMaxima = data.reduce((max, h) => h?.HoraInv > max ? h?.HoraInv : max, data[0]?.HoraInv);
    const horaMinima = data.reduce((min, h) => h?.HoraInv < min ? h?.HoraInv : min, data[0]?.HoraInv);
    const tiempo = diferenciaHoras(horaMaxima ? [horaMaxima, horaMinima] : null, false)
    let fecha = data[0]?.fechaInventario;
    const fechaObj = new Date(fecha);
    const nombreMes = fechaObj.toLocaleDateString('es-ES', { month: 'long' });
    const anio = fechaObj.getFullYear();
    let mesTomaInventario = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1) + " " + anio;
    const UsuariosEscaner = [...new Set(data?.map(item => `${item?.UserName}`))].join(", ")

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [20, 100, 20, 40],

      header: function (currentPage, pageCount, pageSize) {
        return {
          table: {
            widths: ["23%", "55%", "*"],
            body: [
              [
                {
                  image: infoEmpresa?.LogoPrimarioB64,
                  width: 190,
                  margin: [-25, -30, 0, -30],
                  rowSpan: 3,
                },
                {
                    text: infoEmpresa?.NombreLegal,
                    style: "tituloReporteEmpresa",
                },
                data.length > 0 ?
                {
                    text: [
                        {
                            text: "Hora Inicio: ",
                            style: "enunciadoTabla",
                            alignment: "right",

                        },
                        {
                            text: horaMinima,
                            style: "enunciado",
                            alignment: "right",
                        },
                    ],
                } : {},
              ],
              [
                {},
                {
                  text:
                    IdTipoIngreso === 1
                      ? "TOMA INVENTARIO DE MATERIALES"
                      : "TOMA INVENTARIO DE MATERIA PRIMA",
                  style: "tituloReporte",
                },
                data.length > 0 ?
                {
                  text: [
                    {
                      text: "Hora Final: ",
                      style: "enunciadoTabla",
                      alignment: "right",
                    },
                    {
                      text: horaMaxima,
                      style: "enunciado",
                      alignment: "right",
                    },
                  ],
                }: {},
              ],
              [
                {},
                {
                  text: data.length > 0 ? mesTomaInventario : '',
                  style: "tituloReporte",
                },
                data.length > 0 ?
                {
                  text: [
                    {
                      text: "Tiempo: ",
                      style: "enunciadoTabla",
                      alignment: "right",
                    },
                    {
                      text: tiempo,
                      style: "enunciado",
                      alignment: "right",
                    },
                  ],
                } : {},
              ],
            ],
          },
          layout: "noBorders",
          margin: [20, 20, 30, 0],
        };
      },

      footer: function (currentPage, pageCount) {
        return {
          table: {
            widths: ["*", '*'],
            body: [
              [
                {
                  text: "Fecha:" + new Date().toLocaleDateString(),
                  alignment: "left",
                  style: "footer",
                },
                {
                  text: "Página " + currentPage.toString() + " de " + pageCount,
                  alignment: "right",
                  style: "footer",
                },
              ],
            ],
          },
          layout: "noBorders",
          margin: [30, 0, 30, 0],
        };
      },

      content: [

        data.length > 0 ?
        {
            text: [
                {
                    text: "Moneda: ",
                    style: "enunciadoTabla",
                },
                {
                    text: IdMoneda === 1 ? "Dólares" : "Lempiras",
                    style: "enunciado",
                },
            ],
            margin: [5, 0, 0, 0],
        } : null,

        data.length > 0 ? 
        {
          margin: [0, 5, 0, 0],
          layout: "lightHorizontalLines",
          table: {
            widths: [45, 150, 38, 120, 28, '*', '*', "*", "*", 48],
            body: [
              [
                { text: "Codigo", style: "headerTables" },
                { text: "Producto", style: "headerTables" },
                { text: "Inventario", style: "headerTables" },
                { text: "Ubicación", style: "headerTables" },
                { text: "Unidad", style: "headerTables" },
                { text: "Inv.Sistema", style: "headerTables" },
                { text: "Inv. Físico", style: "headerTables" },
                { text: "Balance", style: "headerTables" },
                {style: "headerTables",text: [{ text: "Precio" },{ text: IdMoneda === 1 ? " $ " : " L" }]},
                {style: "headerTables",text: [{ text: "Monto" },{ text: IdMoneda === 1 ? " $ " : " L" }]},
              ],
              ...data?.map(d => [
                { text: d.CodigoProducto, style: 'bodyTables', alignment: 'center' },
                { text: d.NombreProducto, style: 'bodyTables' },
                { text: d.TipoIngreso, style: 'bodyTables', alignment: 'center' },
                { text: d.UbicacionCompleta, style: 'bodyTables', alignment: 'center' },
                { text: d.UnitName, style: 'bodyTables', alignment: 'center' },
                { text: formatNumberDecimal(d.InventarioSistame), style: 'bodyTablesNumeric' },
                { text: formatNumberDecimal(d.Inventario), style: 'bodyTablesNumeric' },
                { text: formatNumberDecimal(d.Balance), style: 'bodyTablesNumeric', color: d.Balance < 0 ? 'red' : ''},
                { text: formatNumberDecimal(IdMoneda === 1 ? d.PrecioD : d.PrecioL), style: 'bodyTablesNumeric' },
                { text: formatNumberDecimal(IdMoneda === 1 ? d.MontoD : d.MontoL), style: 'bodyTablesNumeric' },
              ]),
                [
                    { text: cantidadProductos, style: 'footerTableCenter' }, 
                    { text: '' }, 
                    { text: '' }, 
                    { text: '' }, 
                    { text: '' },
                    { text: formatNumberDecimal(cantidadSistema), style: 'footerTable' },
                    { text: formatNumberDecimal(cantidadInv), style: 'footerTable' },
                    { text: formatNumberDecimal(balanceTotal), style: 'footerTable' },
                    { text: '', style: 'footerTable' },
                    {
                        style: 'footerTable',
                        text: [
                            { text: IdMoneda === 1 ? '$ ' : 'L ' },
                            { text: formatNumberDecimal(IdMoneda === 1 ? montoTotalD : montoTotalL), style: 'footerTable' }
                        ]
                    }
                ]
            ],
          },
        } : {},

        data.length > 0 ?
        {
            margin: [0, 30, 0, 0],
            text: [
                {
                    text: 'Presentado por: ',
                    style: 'enunciadoTabla',
                },
                {
                    text: '',
                    style: 'enunciado',
                },
            ],
        } : null,
        data.length > 0 ?
        {
            margin: [0, 5, 0, 0],
            text: [
                {
                    text: 'Auditado por: ',
                    style: 'enunciadoTabla',
                },
                {
                    text: UsuariosEscaner,
                    style: 'enunciado',
                },
            ],
        } : null,
      ],

      styles: {
        tituloReporte: {
          fontSize: 10,
          bold: true,
          alignment: "center",
        },
        tituloReporteEmpresa: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
        enunciado: {
          fontSize: 10,
        },
        enunciadoTabla: {
          fontSize: 10,
          bold: true,
        },
        headerTables: {
          fontSize: 8,
          margin: [0, 2, 0, 0],
          bold: true,
          alignment: "center",
          fillColor: "lightgray",
        },
        bodyTables: {
            fontSize: 7.5,
        },
        bodyTablesNumeric: {
            fontSize: 8,
            alignment: 'right'
        },
        footerTable: {
            fontSize: 8,
            bold: true,
            alignment: 'right'
        },
        footerTableCenter: {
            fontSize: 8,
            bold: true,
            alignment: 'center'
        },
        footer: {
            fontSize: 10,
            bold: true,
        }

      },
    };

    const doc = pdfMake.createPdf(docDefinition);
    doc.getDataUrl((url) => {
      setReporte(url);
      setLoading(false);
    });
  };

  const CambiaMoneda = (value) => {
      setIdCurrency(value);
      GenerarReporte(data, value, infoEmpresa);
  };

  useEffect(() => {
    if (showReporte) {
      obtenerInformacion();
    }
  }, [showReporte]);

  const onHideReporte = () => {
    setShowReporte(false);
  };

  return (
    <Dialog
      visible={showReporte}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "100vh" }}
      header={
        <div className="pt-4 d-flex gap">
            <span className="p-float-label">
                <Calendar
                    value={fechaReporte}
                    onChange={(e) =>
                        AsignarInformacion(e.value, IdCurrency, infoEmpresa)
                    }
                    style={{ width: 155, height: 50 }}
                    showIcon
                    showButtonBar
                />
                <label>Fecha Reporte</label>
            </span>
            <span className="p-float-label">
                <Dropdown
                    value={IdCurrency}
                    onChange={(e) => CambiaMoneda(e.value)}
                    options={monedas}
                    optionValue="IdCurrency"
                    optionLabel="Currency"
                    style={{ height: 48, width: 150 }}
                />
                <label>Moneda</label>
            </span>
            <Button
                icon="pi pi-refresh"
                loading={loading}
                onClick={() => AsignarInformacion(fechaReporte, IdCurrency, infoEmpresa)}
            />
        </div>
      }
    >
      <Loader loading={loading} querySelector={"#Dialog"} />
      <Toast ref={toast} />
      <div id="Dialog">
        {!loading && reporte && (
          <iframe
            src={reporte}
            style={{ width: "60vw", height: "78vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default ReporteTomaInventario;
